import React from 'react';
import { Col, Container, Row, CardBody } from 'reactstrap';
import PropTypes from 'prop-types';
import AuthorizeAdApi from './components/AuthorizeAdApi';
import { defaultAgencyCode as DEFAULT_AGENCY } from '../../../shared/components/domainSupport';

const AuthAdApiIndex = ({ agencyCode, displayLink }) => (
  <Container className="dashboard">
    <Row>
      <Col md={10}>
        <CardBody>
          <h3 className="page-title">Walmart Advertising API</h3>
        </CardBody>
      </Col>
    </Row>
    <Row>
      <br />
    </Row>
    <Row>
      <AuthorizeAdApi agencyCode={agencyCode} displayLink={displayLink} />
    </Row>
    <Row>
      <br />
    </Row>
  </Container>
);

AuthAdApiIndex.propTypes = {
  agencyCode: PropTypes.string,
  displayLink: PropTypes.string,
};

AuthAdApiIndex.defaultProps = {
  agencyCode: DEFAULT_AGENCY,
  displayLink: 'yes',
};

export default AuthAdApiIndex;
